var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgName = function SvgName(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#name_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.38 1.582a1.5 1.5 0 0 1 1.24 0l3.5 1.59q.199.091.359.23L7 5.642l-4.479-2.24q.16-.139.359-.23zm-4.355 2.69A1.5 1.5 0 0 0 2 4.537v4.826a1.5 1.5 0 0 0 .854 1.353l3.499 1.67q.072.036.146.061V6.51zM7.5 12.447a2 2 0 0 0 .146-.06l3.5-1.67a1.5 1.5 0 0 0 .853-1.354V4.538a1.5 1.5 0 0 0-.023-.267L7.5 6.51zM8.035.671a2.5 2.5 0 0 0-2.07 0L2.466 2.262a2.5 2.5 0 0 0-1.465 2.276v4.826a2.5 2.5 0 0 0 1.423 2.256l3.5 1.67a2.5 2.5 0 0 0 2.153 0l3.5-1.67a2.5 2.5 0 0 0 1.422-2.256V4.538a2.5 2.5 0 0 0-1.465-2.276z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "name_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgName);
export default ForwardRef;